// extracted by mini-css-extract-plugin
export default {"root":"Cashflow_root__FvjkS","grid":"Cashflow_grid__V8y0r"};